import React, { lazy } from 'react';
import { BONUSES } from '../utils/constants';
import { GiftIcon } from 'lucide-react';
import { scrollToOffer } from '../utils/scroll';
export const BonusSection: React.FC = () => {
  return <section className="py-20 px-4 bg-blue-900 text-white" data-id="element-26">
      <div className="container mx-auto max-w-5xl" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-29">
            Y si comprás HOY, te llevás estos 4 BONUS GRATIS
          </h2>
          <p className="text-xl text-blue-200" data-id="element-30">
            Recursos adicionales para acelerar tus resultados
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-31">
          {BONUSES.map((bonus, index) => <div key={index} onClick={scrollToOffer} className="bg-white rounded-2xl overflow-hidden flex flex-col sm:flex-row cursor-pointer transform transition-transform hover:-translate-y-2 duration-300" data-id="element-32">
              <div className="w-full sm:w-2/5 relative h-48 sm:h-auto" data-id="element-33">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" loading="lazy" data-id="element-34" />
                <div className="absolute top-4 left-4 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide shadow-md" data-id="element-35">
                  GRATIS per oggi
                </div>
              </div>

              <div className="w-full sm:w-3/5 p-6 flex flex-col justify-center" data-id="element-36">
                <div className="flex items-center gap-2 text-orange-500 font-bold mb-2" data-id="element-37">
                  <GiftIcon className="w-5 h-5" data-id="element-38" />
                  <span data-id="element-39">BONUS {index + 1}</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight" data-id="element-40">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-sm mb-4 flex-grow" data-id="element-41">
                  {bonus.description}
                </p>
                <div className="flex items-center gap-2" data-id="element-42">
                  <span className="text-gray-400 line-through text-sm" data-id="element-43">
                    Valor: {bonus.value}
                  </span>
                  <span className="text-green-600 font-bold" data-id="element-44">GRATIS</span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-blue-800/50 border border-blue-700 rounded-2xl p-8 text-center max-w-3xl mx-auto mb-10" data-id="element-45">
          <h3 className="text-2xl font-bold text-white" data-id="element-46">
            En total recibirás 9 recursos completos
          </h3>
          <p className="text-blue-200 mt-2" data-id="element-47">
            (5 del Megapack + 4 Bonus Exclusivos)
          </p>
        </div>

        <div className="text-center" data-id="element-48">
          <button onClick={scrollToOffer} className="bg-orange-500 hover:bg-orange-600 text-white rounded-full py-5 px-10 font-bold text-xl md:text-2xl shadow-[0_0_20px_rgba(249,115,22,0.4)] hover:shadow-[0_0_30px_rgba(249,115,22,0.6)] transition-all duration-300" data-id="element-49">
            QUIERO EL PACK + LOS BONUS GRATIS
          </button>
        </div>
      </div>
    </section>;
};